import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditHistoryComponent } from './edit-history.component';



@NgModule({
  declarations: [
    EditHistoryComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    EditHistoryComponent,
  ]
})
export class EditHistoryModule { }
